module.exports = __webpack_public_path__ + "img/NewUserIcon.c2bdf525.svg";